import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Trust from "./sections/Trust";
import Peptides from "./sections/Peptides";
import Assurance from "./sections/Assurance";
import Blends from "./sections/Blends";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Trust />
      <Peptides />
      <Assurance />
      <Blends />
      <Footer />
    </div>;
}